import { store } from "./../../store";
export default class KrAuth {
  constructor(options) {
    this.store = store;
    this.auth = this.store.getters.auth;
    if (this.isLoggedIn()) {
      window.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.auth.access_token;
      //console.log('originL'+window.axioss.headers.common['Authorization']);
      //console.log(window.axioss.headers.common['Authorization']);
    }
  }
  login(data, options = {}) {
    window.axios.defaults.headers.common["Authorization"] =
      "Bearer " + data.data.token;
    var auth = {
      access_token: data.data.token,
      serverTimeOnLogin: data.data.currentTime,
      SOCKET_URL: data.data.socket_url,
      API_URL: data.data.api_url,
      passwordExpired: data.data.passwordExpired,
      isUsingTemporaryPassword: data.data.isUsingTemporaryPassword,
      password_modal_shown: false,
      remember: data.remember === "true" ? true : false,
    };
    var profile = data.data.user;
    //profile.isPaid = data.data.isPaid;
    if (profile.account.version == null) {
      profile.account.version = "full";
    }
    var push = {
      auth: auth,
      profile: profile,
      options: options,
    };
    if (options.impersonate) {
      this.store.dispatch("impersonate_login", push);
    } else {
      this.store.dispatch("login", push);
    }
  }
  logout() {
    if (this.isImpersonation()) {
      this.store.dispatch("impersonate_logout");
    } else {
      delete axios.defaults.headers.common["Authorization"];
      this.store.dispatch("logout");
    }
  }
  isLoggedIn() {
    return this.store.getters.isLoggedIn;
  }
  user(original = false) {
    if (!original) {
      return this.store.getters.profile;
    } else {
      return this.store.getters.originalProfile;
    }
  }
  isImpersonation() {
    return this.store.getters.isImpersonation;
  }
  client() {
    return this.store.getters.client;
  }
  credential() {
    return this.store.getters.auth;
  }
  options() {
    return this.store.getters.options;
  }
  socket() {
    return this.store.getters.socket;
  }
  getAuthHeader() {
    if (this.isLoggedIn) {
      return;
    }
    if (this.token != "") {
      return "Bearer " + this.token;
    } else {
      return false;
    }
  }
}
